<template>
  <div>
    <v-select
      :id="id"
      :items="items"
      :item-text="texto"
      :item-value="valor"
      @change="actualizarCampo"
      :placeholder="placeholder"
      :label="label"
      :item-disabled="disableItem"
      :value="value"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'CampoSelect',
  props: {
    id: {
      type: String
    },
    texto: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    valor: {
      type: String,
      required: true
    },
    disableItem: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array
    },
    onchange: {
      type: Function,
      default: () => ''
    }
  },
  methods: {
    actualizarCampo(payload) {
      this.$emit('input', payload);
      this.onchange();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss"></style>
